import React, { useEffect, useState } from "react";
import { Form, Row, Col, Container } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import config from "../config/config"
import { formStatusUpdatefront } from "../Actions/v1/admin";
import Header from "../Layout/Header";
import Footer from "../Layout/Footer";
import Images from "../Images";
const Formviewdetails = () => {
    const location = useLocation();
    const [data, setData] = useState({});
    const [aprroveStatus, setApproveStatus] = useState(false);
    const [rejectStatus, setRejectStatus] = useState(false);
    const [rejectReason, setRejectReason] = useState("");

    const navigate = useNavigate();
    console.log("locationssss", location)
    const { records, sectionType } = location?.state;
    console.log("YTTTTTTTTTTTTT", aprroveStatus, rejectStatus)
    useEffect(() => {
        setData(location?.state);
        if (records?.status == "approved") {
            setApproveStatus(true);
        }
        else if (records?.status == "rejected") {
            setRejectStatus(true);
            setRejectReason(records?.rejectedreason)
        }
        else {
            setApproveStatus(false);
            setRejectStatus(false);
        }
    }, [location]);
    const isAnswered = (answer) => {
        if (typeof answer === "string") return answer.trim() !== "";
        if (typeof answer === "boolean") return answer === true;
        if (Array.isArray(answer)) {
            return answer.some(item =>
                typeof item === "string" && item.trim() !== "" ||
                typeof item === "boolean" && item === true ||
                typeof item === "object" && item !== null && Object.values(item).some(v =>
                    (typeof v === "string" && v.trim() !== "") ||
                    (typeof v === "boolean" && v === true)
                )
            );
        }
        if (typeof answer === "object" && answer !== null) {
            return Object.values(answer).some(v =>
                (typeof v === "string" && v.trim() !== "") ||
                (typeof v === "boolean" && v === true)
            );
        }
        return false;
    };

    const changeStatus = async (type, records) => {
        try {
            if (sectionType == "exchange") {
                navigate("/listexchange", {
                    state: {
                        records: records,
                        sectionType: type,
                        step: 4,
                        action:"edit"
                    },
                })
            }
            else {
                navigate("/listcointoken", {
                    state: {
                        records: records,
                        sectionType: type,
                        step: 4,
                        action:"edit"
                    },
                })
            }
        } catch (error) {
            console.log("error", error)
        }
    }

    return (
        <>

           <div>
                  <div>
                    <Header />
                    <div className="inner_page position-relative ">
                      <img src={Images.elogo} className="elogo" alt="elogo" />
                      <img
                        src={Images.smallround}
                        className="smallround_footer"
                        alt="round"
                      />
                      <Container className="mt-5 pb-5">

            <div className="cmsedit">
                <button className="themebtn themehoverbtn rounded-1 fbtn py-2 mb-3 fw-600" onClick={() => navigate("/myrequest", { state: { goBackSectionType: sectionType.toLowerCase() }, })}>
                    Back
                </button>
               <h3 className="pb-4 fw-600 text-center">Form Details</h3>
                <div className="cardbox formlist">

                   
                    {records && records?.fields &&
                        Object.entries(records?.fields).map(([sectionName, questions], i) => {
                            let sectionScore = 0;
                            let sectionTotal = 0;
                            return (
                                <React.Fragment key={i}>
                                    <tr>
                                        <td ><h5 className="fw-600 mt-3 mb-3 form_heading">{i + 1 + "." + sectionName}</h5></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>

                                    {Object.entries(questions).map(([question, answerArray], j) => {
                                        const isMainAnswered = answerArray?.includes(".webp")

                                        console.log("WebP Images:", isMainAnswered, `${config.Back_URL}${answerArray}`);

                                        if (!location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question)) {
                                            sectionTotal++;

                                        }
                                        if (isAnswered(answerArray) && !location?.state?.ques?.find(val => val.stepName == sectionName)?.inputs?.find(val => val.subheading == question)) sectionScore++;
                                        return (
                                            <React.Fragment key={j}>
                                                <tr>
                                                    {/* <td></td> */}
                                                    <td className="fw-600">{`${question}`}</td>
                                                    <td className="text-center px-2">
                                                    </td>
                                                    <Col className="mb-4">
                                                      
                                                        {!isMainAnswered ?
                                                            !(Array.isArray(answerArray) && answerArray.every(item => typeof item === 'object' && item !== null && !Array.isArray(item))) &&
                                                            (
                                                                <Form.Group>

                                                                    {Array.isArray(answerArray) ? (
                                                                        answerArray.map((item, idx) => (
                                                                            <Form.Control
                                                                                key={idx}
                                                                                type="text"
                                                                                value={
                                                                                    isAnswered(answerArray) ?
                                                                                        typeof item === "string" && item.includes("T") && !isNaN(Date.parse(item))
                                                                                            ? item.split("T")[0]
                                                                                            : typeof item === "object"
                                                                                                ? ""
                                                                                                : String(item)
                                                                                        :
                                                                                        "null"
                                                                                }
                                                                                disabled={true}
                                                                                className="mb-2"
                                                                            />
                                                                        ))
                                                                    ) : (
                                                                        <Form.Control
                                                                            type="text"
                                                                            value={
                                                                                location?.state?.ques?.find(val => val.stepName === sectionName)?.inputs?.find(val => val.subheading === question)
                                                                                    ? ""
                                                                                    : isAnswered(answerArray)
                                                                                        ? typeof answerArray === "string"
                                                                                            ? answerArray.includes("T") && !isNaN(Date.parse(answerArray))
                                                                                                ? answerArray.split("T")[0]
                                                                                                : answerArray
                                                                                            : typeof answerArray === "object"
                                                                                                ? answerArray
                                                                                                : String(answerArray)
                                                                                        : "null"
                                                                            }
                                                                            disabled={true}
                                                                        />
                                                                    )}
                                                                </Form.Group>
                                                            ) : (
                                                                <Form.Group>
                                                                    {Array.isArray(answerArray) ? (
                                                                        answerArray.map((item, idx) =>
                                                                            typeof item === "string" && item.endsWith(".webp") ? (
                                                                                <img
                                                                                    key={idx}
                                                                                    src={`${config.Back_URL}formImage/${item}`}
                                                                                    alt={`Uploaded-${idx}`} 
                                                                                    className="imgset"
                                                                                    // style={{ maxWidth: "50%", height: "auto", borderRadius: "8px", marginBottom: "10px" }}
                                                                                />
                                                                            ) : (
                                                                                <div key={idx}>{String(item)}</div>
                                                                            )
                                                                        )
                                                                    ) : typeof answerArray === "string" && answerArray.endsWith(".webp") ? (
                                                                        <img
                                                                            src={`${config.Back_URL}formImage/${answerArray}`}
                                                                            alt="Uploaded"
                                                                            className="imgset"
                                                                            // style={{ maxWidth: "50%", height: "auto", borderRadius: "8px" }}
                                                                        />
                                                                    ) : (
                                                                        <div>{String(answerArray)}</div>
                                                                    )}
                                                                </Form.Group>
                                                            )}

                                                    </Col>
                                                </tr>
                                                {Array.isArray(answerArray) &&
                                                    answerArray?.map((answerGroup, k) =>
                                                        typeof answerGroup === 'object' && !Array.isArray(answerGroup) ? (
                                                            Object.entries(answerGroup).map(([param, value], l) => {
                                                                if (isAnswered(value)) sectionScore++;
                                                                console.log("sub_inputes", param, value)
                                                                const isSubAnswered = isAnswered(value);
                                                                sectionTotal++;
                                                                return (
                                                                    <tr key={`${j}-${k}-${l}`}>
                                                                        {console.log("location?.state?.ques?.find(val=>val.stepName == sectionName).subinputs?.find(val=>val.subheading == param)", location?.state?.ques?.find(val => val.stepName == sectionName).inputs?.find(val => val.subheading == question).subinputs?.find(val => val.name == param))}
                                                                        {/* <td></td> */}
                                                                        <td>{param}</td>
                                                                      
                                                                        <td className="text-center px-2">
                                                                        </td>
                                                                        <Col xs={12} sm={12} md={6} lg={6} xl={4} xxl={4} className="mb-4">
                                                                            <Form.Group>
                                                                                <Form.Control
                                                                                    type="text"
                                                                                    value={isAnswered(value) ? value : "null"}
                                                                                    disabled={true}
                                                                                />
                                                                            </Form.Group>
                                                                        </Col>
                                                                    </tr>
                                                                )
                                                            })
                                                        ) : null
                                                    )}
                                            </React.Fragment>
                                        )
                                    })}

                                </React.Fragment>
                            )
                        }
                        )
                    }

                    {
                   records && (records?.status == "approved" || records?.status == "pending") 
                    ?
                        // <div className="d-flex gap-3 flex-wrap pt-2">
                        //     <button disabled className="themebtn themehoverbtn rounded-1 fbtn py-2 px-3 fw-600" onClick={() => changeStatus(sectionType, records)}>Edit</button>
                        // </div>
                        <></>
                        :
                        records?.status == "rejected" 
                        ?
                        <div className="d-flex gap-3 align-items-center flex-wrap pt-2">
                            <textarea
                                disabled
                                type="text"
                                className="w-100 p-3"
                                rows={4}
                                value={rejectReason || ""}
                                onChange={(e) => setRejectReason(e.target.value)}
                            />
                            <button className="themebtn themehoverbtn rounded-1 fbtn py-2 px-3 fw-600" onClick={() => changeStatus(sectionType, records)}>Edit</button>
                        </div>
                        :
                        <button disabled className="themebtn themehoverbtn rounded-1 fbtn py-2 px-3 fw-600" onClick={() => changeStatus(sectionType, records)}>Edit</button>
                    }

                </div>
            </div>

            </Container>
   </div>
          <Footer />
        </div>
      </div>

        </>
    );
};

export default Formviewdetails;
